(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  const initializeCollectionCards = container => container.querySelectorAll('[data-bts-collection-product]').forEach(card => {
    if (card.dataset.btsInitialized) return;
    card.dataset.btsInitialized = 'true';
    const slides = [...card.querySelectorAll('[data-bts-collection-slide]')];
    const counter = card.querySelector('[data-bts-collection-counter]');
    let activeIndex = 0;
    const showSlide = index => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== activeIndex; });
      if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
    };
    card.querySelector('[data-bts-collection-previous]')?.addEventListener('click', () => showSlide(activeIndex - 1));
    card.querySelector('[data-bts-collection-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
    card.querySelector('[data-bts-collection-variant]')?.addEventListener('change', event => {
      const option = event.target.selectedOptions[0];
      const price = card.querySelector('[data-bts-collection-price]');
      const compare = card.querySelector('[data-bts-collection-compare]');
      const sale = card.querySelector('[data-bts-collection-sale]');
      const submit = card.querySelector('[data-bts-collection-submit]');
      const available = option.dataset.available === 'true';
      price.textContent = option.dataset.price; compare.textContent = option.dataset.compare || '';
      compare.classList.toggle('is-hidden', !option.dataset.compare); sale.classList.toggle('is-hidden', !option.dataset.compare);
      submit.disabled = !available; submit.textContent = available ? 'Add to cart' : 'Sold out';
    });
  });
  initializeCollectionCards(document);

  document.querySelectorAll('[data-bts-infinite-collection]').forEach(section => {
    const products = section.querySelector('.bts-collection-shop__products');
    const loader = section.querySelector('[data-bts-load-more]');
    const link = loader?.querySelector('[data-bts-next-page]');
    const status = loader?.querySelector('[data-bts-load-status]');
    if (!products || !link || !status) return;
    let loading = false;
    let observer;
    const loadNext = async () => {
      if (loading || !link.hasAttribute('href')) return;
      loading = true;
      observer?.unobserve(loader);
      link.setAttribute('aria-disabled', 'true');
      products.setAttribute('aria-busy', 'true');
      status.textContent = 'Loading more products…';
      try {
        const response = await fetch(link.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection could not load');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextSection = page.querySelector('[data-bts-infinite-collection]');
        const cards = nextSection?.querySelectorAll('[data-bts-collection-product]');
        if (!cards?.length) throw new Error('No product content returned');
        products.append(...cards);
        initializeCollectionCards(products);
        const nextLink = nextSection.querySelector('[data-bts-next-page]');
        if (nextLink) {
          link.href = nextLink.getAttribute('href');
          status.textContent = `${cards.length} more products loaded.`;
          observer?.observe(loader);
        } else {
          link.removeAttribute('href');
          link.hidden = true;
          status.textContent = 'You’ve reached the end of the collection.';
          observer?.disconnect();
        }
      } catch (_) {
        status.textContent = 'Unable to load more products. Select “Load more products” to try again.';
        // Leave the link available for an explicit retry instead of looping requests.
      } finally {
        loading = false;
        link.removeAttribute('aria-disabled');
        products.removeAttribute('aria-busy');
      }
    };
    link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      loadNext();
    });
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) loadNext();
      }, { rootMargin: '1000px 0px' });
      observer.observe(loader);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-bts-product-page]').forEach(page => {
    const closeControl = page.querySelector('[data-bts-pdp-close]');
    const backControl = page.querySelector('[data-bts-pdp-back]');
    let returnCollectionPanel = '';
    let returnCollectionUrl = '';
    try {
      returnCollectionPanel = window.sessionStorage.getItem('bts:returnCollectionPanel') || '';
      returnCollectionUrl = window.sessionStorage.getItem('bts:returnCollectionUrl') || '';
      if (returnCollectionUrl && new URL(returnCollectionUrl).origin === window.location.origin) {
        backControl.href = returnCollectionUrl;
      }
    } catch (error) {
      returnCollectionPanel = '';
      returnCollectionUrl = '';
    }

    backControl?.addEventListener('click', event => {
      try {
        const previousPage = new URL(document.referrer);
        if (returnCollectionPanel) window.sessionStorage.setItem('bts:reopenCollectionPanel', returnCollectionPanel);
        if (previousPage.origin === window.location.origin && window.history.length > 1) {
          event.preventDefault();
          window.history.back();
        }
      } catch (error) {
        // The link returns to the saved catalog URL or the product collection fallback.
      }
    });

    closeControl?.addEventListener('click', event => {
      try {
        window.sessionStorage.removeItem('bts:returnCollectionPanel');
        window.sessionStorage.removeItem('bts:returnCollectionUrl');
        window.sessionStorage.removeItem('bts:reopenCollectionPanel');
        const previousPage = new URL(document.referrer);
        if (previousPage.origin === window.location.origin && window.history.length > 1) {
          event.preventDefault();
          window.history.back();
        }
      } catch (error) {
        // The link's collection fallback handles direct visits without a valid referrer.
      }
    });
    const slides = [...page.querySelectorAll('[data-bts-pdp-slide]')];
    const thumbnails = [...page.querySelectorAll('[data-bts-pdp-thumbnail]')];
    const counter = page.querySelector('[data-bts-pdp-counter]');
    const lightbox = page.querySelector('[data-bts-pdp-lightbox]');
    const lightboxImage = page.querySelector('[data-bts-pdp-lightbox-image]');
    let activeIndex = 0;
    const showSlide = index => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => { const active = slideIndex === activeIndex; slide.hidden = !active; slide.classList.toggle('is-active', active); });
      thumbnails.forEach((thumbnail, thumbnailIndex) => { const active = thumbnailIndex === activeIndex; thumbnail.classList.toggle('is-active', active); thumbnail.setAttribute('aria-current', active ? 'true' : 'false'); });
      if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
    };
    page.querySelector('[data-bts-pdp-previous]')?.addEventListener('click', () => showSlide(activeIndex - 1));
    page.querySelector('[data-bts-pdp-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => showSlide(index)));
    page.querySelector('[data-bts-pdp-zoom]')?.addEventListener('click', () => { const image = slides[activeIndex]?.querySelector('img'); if (!image || !lightbox || !lightboxImage) return; lightboxImage.src = image.currentSrc || image.src; lightboxImage.alt = image.alt; lightbox.showModal(); });
    page.querySelector('[data-bts-pdp-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
    lightbox?.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
    const quantity = page.querySelector('input[name="quantity"]');
    page.querySelector('[data-bts-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, (Number.parseInt(quantity.value, 10) || 1) - 1); });
    page.querySelector('[data-bts-quantity-plus]')?.addEventListener('click', () => { quantity.value = (Number.parseInt(quantity.value, 10) || 1) + 1; });
    const variantSelect = page.querySelector('[data-bts-pdp-variant]');
    const optionGroups = [...page.querySelectorAll('[data-bts-option-group]')];
    const variantsData = page.querySelector('[data-bts-pdp-variants]');
    let variants = [];
    try { variants = variantsData ? JSON.parse(variantsData.textContent) : []; } catch (error) { variants = []; }
    const showVariantMedia = variant => {
      const mediaId = variant?.featured_media?.id;
      if (!mediaId) return;
      const mediaIndex = slides.findIndex(slide => slide.dataset.btsMediaId === String(mediaId));
      if (mediaIndex >= 0) showSlide(mediaIndex);
    };
    const selectedOptions = () => optionGroups.map(group => group.querySelector('[data-bts-option-input]:checked')?.value || '');
    const updateOptionAvailability = () => {
      optionGroups.forEach((group, optionIndex) => {
        group.querySelectorAll('[data-bts-option-input]').forEach(input => {
          const available = variants.some(variant => variant.available && variant.options?.[optionIndex] === input.value);
          input.disabled = !available;
          input.nextElementSibling?.classList.toggle('is-unavailable', !available);
          input.nextElementSibling?.setAttribute('aria-disabled', available ? 'false' : 'true');
        });
      });
    };
    const selectMatchingVariant = () => {
      const choices = selectedOptions();
      const variant = variants.find(item => item.options?.every((value, index) => value === choices[index]));
      const price = page.querySelector('[data-bts-pdp-price]');
      const compare = page.querySelector('[data-bts-pdp-compare]');
      const sale = page.querySelector('[data-bts-pdp-sale]');
      const submit = page.querySelector('[data-bts-pdp-submit]');
      if (!variant || !variantSelect) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }
      variantSelect.value = String(variant.id);
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    };
    variantSelect?.addEventListener('change', event => {
      const option = event.target.selectedOptions[0];
      const price = page.querySelector('[data-bts-pdp-price]');
      const compare = page.querySelector('[data-bts-pdp-compare]');
      const sale = page.querySelector('[data-bts-pdp-sale]');
      const submit = page.querySelector('[data-bts-pdp-submit]');
      const available = option.dataset.available === 'true';
      price.textContent = option.dataset.price; compare.textContent = option.dataset.compare || '';
      compare.classList.toggle('is-hidden', !option.dataset.compare); sale.classList.toggle('is-hidden', !option.dataset.compare);
      submit.disabled = !available; submit.textContent = available ? 'Add to cart' : 'Sold out';
      const variant = variants.find(item => String(item.id) === option.value);
      showVariantMedia(variant);
      window.history.replaceState({}, '', `${window.location.pathname}?variant=${option.value}`);
    });
    optionGroups.forEach(group => group.addEventListener('change', event => {
      if (!event.target.matches('[data-bts-option-input]')) return;
      selectMatchingVariant();
      updateOptionAvailability();
    }));
    updateOptionAvailability();
    showVariantMedia(variants.find(item => String(item.id) === variantSelect?.value));
  });

  } catch(e) { console.error(e); }
})();
})();
